module.exports = __webpack_public_path__ + "static/media/rec_point1.dd42cf07.svg";